import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Button from "../../../../shared/button/button";
import Card from "../../../../shared/Card/Card";
import { bindActionCreators } from "redux";
import { setStep } from "../../../actions/advanced-management";
import ModalTerms from "../../../../shared/ModalTerms/ModalTerms";
import { withGetScreen } from "react-getscreen";
import AdvancedManagementTermsDesktop from "../template/AdvancedManagementTermsDesktop";
import AdvancedManagementTermsMobile from "../template/AdvancedManagementTermsMobile";
import { BOTH_DECLARATIONS, renderTermsDescription } from "../../../shared/terms";
import { TermsProvider } from "../../../../shared/Terms/TermsProvider";
import { publish } from "pubsub-js";
import eventType from "../../../events/eventType";
import { ACCOUNT_FAMILY_EVENT } from "../../../events/ga/events";

class AdvancedManagementTerms extends Component {
	constructor() {
		super();
		this.state = {
			ifRenderModalTerms: false
		};
	}

	onRenderModalTerms = () => {
		this.setState({
			ifRenderModalTerms: !this.state.ifRenderModalTerms
		});
	};


	render() {
		const { ifRenderModalTerms } = this.state;

		const handleEvent = (type) => {
			publish(eventType.ACCOUNT_FAMILY, {
				type: type
			})
		}

		return (
			<>
				<div className="advanced-management-terms">
					<Card withoutMargin>
						{this.props.isMobile() || this.props.isTablet() ? (
							<AdvancedManagementTermsMobile />
						) : (
							<AdvancedManagementTermsDesktop />
						)}
						<div className="advanced-management-terms--download-declaration advanced-management-terms--mobile--download-declaration-padding">
							<a href={BOTH_DECLARATIONS} target="_blank" onClick={() => {
								handleEvent(ACCOUNT_FAMILY_EVENT.button_download)
							}}>
								<i className="icon-export" />
								Baixar Declaração de Vínculo
								{!this.props.isMobile() && !this.props.isTablet() ? " do gestor" : false}
							</a>
						</div>
						<p className="advanced-management-terms--mobile--download-declaration-padding">
							Conheça aqui as{" "}
							<a
								className="advanced-management-terms--download-declaration--rules-to-use"
								onClick={() => {
									handleEvent(ACCOUNT_FAMILY_EVENT.button_rule)
									this.onRenderModalTerms();
								}}
							>
								regras de utilização{" "}
								{!this.props.isMobile() && !this.props.isTablet()
									? "do gestor da Conta Família"
									: false}
							</a>
						</p>
					</Card>
					<div className="advanced-management-terms__actions">
						<Button
							onClick={() => {
								handleEvent(ACCOUNT_FAMILY_EVENT.button_start)
								this.props.setStep(2);
							}}
							className="btn btn-primary-lg"
							type="button"
						>
							Começar
						</Button>
					</div>
				</div>

				{ifRenderModalTerms && (
					<TermsProvider slug="family-account-manager">
						{({ content, loading, error }) => (
							<ModalTerms
								ifShow={ifRenderModalTerms}
								onClose={this.onRenderModalTerms}
								dataDescription={renderTermsDescription({ loading, error, content })}
							></ModalTerms>
						)}
					</TermsProvider>
				)}
			</>
		);
	}
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setStep
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(
	withGetScreen(AdvancedManagementTerms, {
		mobileLimit: 469, // TODO Fix screen vars
		tabletLimit: 769, // TODO Fix screen vars
		shouldListenOnResize: true
	})
);
